import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";

import RecipeForm from "../../../components/Recipe/RecipeForm";

import "./AddRecipe.css";

export default function AddRecipePage() {
  const navigate = useNavigate();

  return (
    <div className="add-recipe-page">
      <div className="add-recipe-header">
        <Button
          type="link"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate("/dashboard/recipes")}
          style={{ paddingLeft: 0 }}
        >
          Back to All Recipes
        </Button>
      </div>

      <RecipeForm
        mode="add"
        onSuccess={() => navigate("/dashboard/recipes")}
      />
    </div>
  );
}
